import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-maintenance-page',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './app-maintenance-page.component.html',
    styleUrls: ['./app-maintenance-page.component.scss'],
})
export class AppMaintenancePageComponent {
    readonly appName = environment.app?.name || environment.app?.label || 'Ashcorp';
    readonly logo = environment.layout?.logo || '';
    readonly supportEmail = environment.support?.email || 'support@ashcorp.co';

    get message(): string {
        const lifecycleMessage = environment.app_lifecycle?.banner?.message;
        if (lifecycleMessage) {
            return lifecycleMessage;
        }

        return 'This application is temporarily unavailable. Please check back later or contact support.';
    }
}
